import { render, staticRenderFns } from "./CustomFieldLogs.vue?vue&type=template&id=a9ca7458&scoped=true&"
import script from "./CustomFieldLogs.vue?vue&type=script&lang=js&"
export * from "./CustomFieldLogs.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldLogs.vue?vue&type=style&index=0&id=a9ca7458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ca7458",
  null
  
)

export default component.exports